import { Component, OnInit, OnChanges, ViewChild, Input, ComponentFactoryResolver } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReportService } from '../../shared/services/report.service';
import { SpinnerService } from '../../shared/components/spinner/spinner.service';
import { MailingService } from '../../shared/services/mailing.service';
import { Mailing } from '../../shared/models/Mailing';

@Component({
  selector: 'app-mailing-notes',
  templateUrl: './mailing-notes.component.html'
})

export class MailingNotesComponent implements OnInit {
  private sub: any;
  private id: number; // id
  public contentType = 1;
  public mailing: Mailing; // mailing model

  constructor(
    private mailingService: MailingService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private spinnerService: SpinnerService,
  ) { }
  
  // init
  ngOnInit() {

    // show spinner on page load
    this.spinnerService.show();

    // get url parameter id 
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number

      this.getMailing(this.id);

      // hide spinner
      setTimeout(() => {
        this.spinnerService.hide();
      }, 1500);
    });
  }


  // get mailing details
  getMailing(id: number) {

    // get mailing
    this.mailingService.getById(this.id).subscribe(result => {

      this.mailing = result;

      // hide spinner
      setTimeout(() => {
        this.spinnerService.hide();
      }, 1500);

    }, error =>
      // console.error(error)
      this.router.navigate(['/mailings/'])
    );
  }
}


